import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {BaseService} from './BaseService';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner'
import 'rxjs/add/operator/map';

@Injectable()
export class LoginService {



    //private headers = new Headers({ 'Content-Type': 'application/json' });
    //private headers = new Headers({'Content_Type': 'application/x-www-form-urlencoded'});

    constructor(private http: HttpClient, private baseurl: BaseService, private spinnerService: Ng4LoadingSpinnerService) {
    }

    loginvalidate(user: any) {
        let url: string = '/userlogin';
        let body = JSON.stringify(user);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        console.log("url" + url);
        console.log("body" + body);
        console.log("baseurl" + this.baseurl.url);
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res: Response) => {
            res;
            this.spinnerService.hide()
            return res
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

        //            if (res){
        //                return false;
        //
        //            }
        //            else {
        //                return true;
        //            }
        //        });
    }

    updatepassword(user: any) {
        console.log(user);
        let url: string = '/changepassword';
        let body = JSON.stringify(user);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res: Response) => {
            res;
            this.spinnerService.hide()
            return res
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }

    sealDetails(user: any) {
        let url: string = '/sealDetails';
        let body = JSON.stringify({
            companyid: user.companyid
        });
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res: Response) => {
            res;
            this.spinnerService.hide()
            return res
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }

    generateRandomPassword(data) {
        let url: string = '/generateRandomPassword';
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        let body = JSON.stringify(data);
        console.log(body);
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res: any) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            })
    }
    getMultipleusers(user: any) {
        let url: string = '/userss';
        let body = JSON.stringify(user);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        console.log("url" + url);
        console.log("body" + body);
        console.log("baseurl" + this.baseurl.url);
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res: Response) => {
            res;
            this.spinnerService.hide()
            return res
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });


    }
     getTenantConfig(user: any) {
        let url: string = '/getTenantConfig';
        let body = JSON.stringify(user);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        console.log("url" + url);
        console.log("body" + body);
        console.log("baseurl" + this.baseurl.url);
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res: Response) => {
            res;
            this.spinnerService.hide()
            return res
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });


    }
}


// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/service/LoginService.ts